<p>status-wise-average-time works!</p>
